/**
 * ROBO-743. `X-HD-Source` names the caller to the API's audit log, so a change reads as coming from
 * the new UX, the Hubby panel, a Hubby Action, the MCP connector and so on, and not just "this user".
 * The API resolves it in `Services/AuditTrail/ChangeSource.cs`; the values below are its constants.
 *
 * A label, not a credential: it changes which source a change is filed under, never who made it.
 *
 * No imports, on purpose: `services/http` and `hubby-core/tool-api` both read it, and hubby-core is
 * bundled for hosts with no browser.
 */
export const HD_SOURCE_HEADER = 'X-HD-Source';

/** Every request the page itself makes. */
export const HD_SOURCE_UX = 'ux';

/** A request a Hubby tool makes from the panel. */
export const HD_SOURCE_HUBBY_PANEL = 'hubby-panel';
